import { FormikConfig, useFormik } from 'formik';
import React, { useEffect } from 'react';
import { IValueWithTime } from '../../../types/channel-types';
import InputControl from '../../InputControl/InputControl';
import InteractiveButton from '../../InteractiveButton/InteractiveButton';

export type SingleValueFormWithUpdateProps<T, K> = React.InputHTMLAttributes<HTMLInputElement> & {
  values: T;
  //TODO
  //ADD validation schema
  validationSchema?: FormikConfig<T>['validationSchema'];
  onSubmit: FormikConfig<T>['onSubmit'];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => any
  label: string;
  btnText?: string;
  currentValues: IValueWithTime<K>;
};

export const SingleFormWithUpdate = <T, K>(props: SingleValueFormWithUpdateProps<T, K>) => {
  const { values, currentValues, onSubmit, onChange, validationSchema, ...otherProps } = props;
  const formik = useFormik({
    initialValues: values,
    validationSchema,
    onSubmit,
  });

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
    formik.handleChange(event);
  };

  useEffect(() => {
    formik.resetForm({ values });
    return () => formik.resetForm({ values });
  }, [values]);

  return (
    <form className="p-7" onSubmit={formik.handleSubmit}>
      {Object.keys(values).map((item) => {
        return (
          <div className='flex w-full' key={item}>
            <div className='flew flex-col flex-auto'>
              <InputControl
                label={otherProps.label}
                type={otherProps.type}
                name={item}
                placeholder={otherProps.placeholder}
                value={formik.values[item]}
                customOnChange={onChangeHandler}
                onBlur={formik.handleBlur}
                showError={formik.touched[item] && formik.errors[item]}
                errorText={formik.errors[item]}
              />
              <InteractiveButton text={otherProps.btnText ?? 'Update'} submit isLoading={formik.isSubmitting} />
            </div>
          </div>
        );
      })}
    </form>
  );
};
